// extracted by mini-css-extract-plugin
export var container = "_h0-0";
export var content = "_h0-3";
export var customerTitle = "_h0-4";
export var empty = "_h0-5";
export var gray = "_h0-6";
export var header = "_h0-7";
export var info = "_h0-8";
export var loading = "_h0-2";
export var loadingCard = "_h0-9";
export var oneLine = "_h0-a";
export var personName = "_h0-e";
export var pillContainer = "_h0-b";
export var selected = "_h0-1";
export var text = "_h0-c";
export var twoLines = "_h0-d";
export var unread = "_h0-f";
export var unreadIndicator = "_h0-g";